import {CgPlayListAdd} from 'react-icons/cg'

import Header from '../Header'
import Sidebar from '../Sidebar'
import TrendingVideo from '../TrendingVideo'

import ModeContext from '../../context/ModeContext'

import {
  Flex,
  TrendingContainer,
  TrendingCard,
  TrendingIcon,
  TrendingTitle,
  TrendingVideos,
} from '../Trending/styledComponents'

import {NoResults, NoRImg, NoR, NoRPara} from '../Home/styledComponents'

const SavedVideos = () => (
  <ModeContext.Consumer>
    {value => {
      const {isDarkMode, savedVideos} = value

      const containerBg = isDarkMode ? '#0f0f0f' : '#f1f1f1'
      const cardBg = isDarkMode ? '#181818' : '#ebebeb'
      const iconBg = isDarkMode ? '#0f0f0f' : '#e2e8f0;'
      const color = isDarkMode ? 'white' : 'black'
      const bg = isDarkMode ? '#0f0f0f' : '#f1f1f1'

      if (savedVideos.length > 0) {
        return (
          <>
            <Header />
            <Flex>
              <Sidebar />
              <TrendingContainer containerBg={containerBg}>
                <TrendingCard cardBg={cardBg}>
                  <TrendingIcon iconBg={iconBg}>
                    <CgPlayListAdd />
                  </TrendingIcon>
                  <TrendingTitle color={color}>Saved Videos</TrendingTitle>
                </TrendingCard>
                <TrendingVideos>
                  {savedVideos.map(each => (
                    <TrendingVideo key={each.id} video={each} />
                  ))}
                </TrendingVideos>
              </TrendingContainer>
            </Flex>
          </>
        )
      }

      return (
        <>
          <Header />
          <Flex>
            <Sidebar />
            <NoResults bg={bg}>
              <NoRImg
                failure
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-saved-videos-img.png"
                alt="no saved videos"
              />
              <NoR color={color}>No saved videos found</NoR>
              <NoRPara>You can save your videos while watching them.</NoRPara>
            </NoResults>
          </Flex>
        </>
      )
    }}
  </ModeContext.Consumer>
)

export default SavedVideos
